import React from 'react';
import { Award, Target, Heart, Shield } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { aboutCompany } from '../utils/mockData';

const ChiSiamo = () => {
  const valueIcons = {
    0: Award,
    1: Target,
    2: Heart,
    3: Shield
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_edil-service/artifacts/b8hmdnhd_dji_fly_20250719_105736_31_1752915506505_photo_optimized.jpeg"
            alt="Edil Service Facility"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-800/70"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Chi Siamo
            </h1>
            <p className="text-xl text-slate-300 leading-relaxed">
              Qualità, esperienza e affidabilità al servizio del territorio
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
                La Nostra Storia
              </h2>
              <p className="text-lg text-slate-700 leading-relaxed mb-6">
                {aboutCompany.description}
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                Situati a San Ferdinando di Puglia, serviamo con orgoglio tutto il territorio della provincia di Barletta-Andria-Trani e oltre, 
                fornendo materiali edili di prima qualità e un servizio clienti che fa la differenza. La nostra esperienza pluriennale ci permette 
                di comprendere le esigenze specifiche di ogni cliente, offrendo soluzioni su misura per ogni tipo di progetto.
              </p>
            </div>

            {/* Company Image */}
            <div className="mb-16 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_edil-service/artifacts/j0bgqp2x_b0b2bb1f-e65f-4804-aa2e-408db187fdc0.jpeg"
                alt="Edil Service 2.0 Struttura"
                className="w-full h-auto"
              />
            </div>

            {/* Values */}
            <div className="mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-12 text-center">
                I Nostri Valori
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {aboutCompany.values.map((value, index) => {
                  const Icon = valueIcons[index];
                  return (
                    <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-shadow">
                      <CardContent className="p-8">
                        <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center text-white mb-6">
                          <Icon size={32} />
                        </div>
                        <h3 className="text-2xl font-bold text-slate-800 mb-3">
                          {value.title}
                        </h3>
                        <p className="text-slate-600 leading-relaxed">
                          {value.description}
                        </p>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            </div>

            {/* Mission */}
            <div className="bg-gradient-to-br from-slate-800 to-slate-700 rounded-2xl p-12 text-white">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                La Nostra Missione
              </h2>
              <p className="text-xl text-slate-200 leading-relaxed mb-6">
                Essere il punto di riferimento nel settore della distribuzione di materiali edili, offrendo prodotti di qualità 
                superiore a prezzi competitivi, accompagnati da un servizio clienti eccellente e consulenza tecnica specializzata.
              </p>
              <p className="text-lg text-slate-300 leading-relaxed">
                Ci impegniamo ogni giorno a supportare i nostri clienti nella realizzazione dei loro progetti, 
                garantendo disponibilità, competenza e soluzioni innovative per ogni esigenza del settore edilizio e agricolo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team / Contact CTA */}
      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
              Vieni a Trovarci
            </h2>
            <p className="text-xl text-slate-600 mb-8 leading-relaxed">
              Il nostro team di professionisti è a tua disposizione per consigliarti e supportarti 
              nella scelta dei materiali più adatti al tuo progetto.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="/contatti" 
                className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-700 hover:to-orange-600 text-white font-semibold rounded-lg shadow-lg transition-all"
              >
                Contattaci
              </a>
              <a 
                href="tel:0883620626" 
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-slate-800 text-slate-800 hover:bg-slate-800 hover:text-white font-semibold rounded-lg transition-all"
              >
                Chiamaci Ora
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChiSiamo;
